import AgreementCardTitle from "assets/locales/ja/AgreementCardTitle.js"
import AgreementModal from "assets/locales/ja/AgreementModal.js"
import ServiceAgreement from "assets/locales/ja/ServiceAgreement.js"
import SorryPage from "assets/locales/ja/SorryPage.js"
import TextCopyright from "assets/locales/ja/TextCopyright.js"
import LanguageSwitch from "assets/locales/ja/LanguageSwitch.js"

export default {
  ...AgreementCardTitle,
  ...AgreementModal,
  ...ServiceAgreement,
  ...SorryPage,
  ...TextCopyright,
  ...LanguageSwitch,
}
